import { NavLink } from 'react-router-dom';
import { LayoutDashboard, History, TrendingUp, Settings, ScrollText, Activity, Target } from 'lucide-react';

const links = [
  { to: '/', icon: LayoutDashboard, label: 'Overview' },
  { to: '/trades', icon: History, label: 'Trades' },
  { to: '/strategies', icon: TrendingUp, label: 'Strategies' },
  { to: '/scorecard', icon: Target, label: 'Scorecard' },
  { to: '/config', icon: Settings, label: 'Config' },
  { to: '/logs', icon: ScrollText, label: 'Logs' },
];

interface SidebarProps {
  healthy: boolean;
}

export default function Sidebar({ healthy }: SidebarProps) {
  return (
    <aside className="w-56 min-h-screen bg-trader-card border-r border-trader-border flex flex-col">
      <div className="p-4 border-b border-trader-border">
        <h1 className="text-lg font-bold text-trader-profit tracking-tight">Polymarket</h1>
        <p className="text-xs text-trader-muted">Trading Dashboard</p>
      </div>
      <nav className="flex-1 p-2">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? 'bg-trader-profit/10 text-trader-profit'
                  : 'text-trader-muted hover:text-trader-text hover:bg-white/5'
              }`
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-trader-border">
        <div className="flex items-center gap-2 text-xs">
          <Activity size={14} className={healthy ? 'text-trader-profit' : 'text-trader-loss'} />
          <span className={healthy ? 'text-trader-profit' : 'text-trader-loss'}>
            {healthy ? 'API Connected' : 'API Disconnected'}
          </span>
        </div>
      </div>
    </aside>
  );
}
